function toolkitSlugs(items = []) {
  return items
    .map((item) => String(item?.toolkit || item?.toolkit_slug || '').toLowerCase())
    .filter(Boolean)
}

export function conversationSearchFacets(row = {}) {
  const documentIds = Array.isArray(row.pageindex_document_ids)
    ? row.pageindex_document_ids.map(String).filter(Boolean)
    : []
  const metadata = row.metadata && typeof row.metadata === 'object' ? row.metadata : {}
  const requestedToolkits = toolkitSlugs([
    ...(metadata.connect_requests || []),
    ...(metadata.integration_access_reviews || []),
  ])
  return {
    documentIds,
    hasDocuments: documentIds.length > 0,
    requestedToolkits,
  }
}
